var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBmiMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "#B3E2D7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 9H7.78118C8.66019 9 9.32601 9.06996 9.77763 9.21029C10.2307 9.35062 10.5963 9.63549 10.8741 10.0637C11.1526 10.4903 11.2914 11.181 11.2914 12.1313C11.2914 12.7759 11.1935 13.2234 10.9965 13.4773C10.7998 13.7308 10.4133 13.9263 9.83452 14.062C10.4796 14.2112 10.9164 14.4588 11.1452 14.8048C11.3752 15.1525 11.49 15.6824 11.49 16.3984V17.419C11.49 18.162 11.4075 18.7109 11.2415 19.0689C11.0756 19.4273 10.8119 19.6719 10.4504 19.803C10.0886 19.9343 9.34593 20 8.22479 20H5.00041V9H5ZM7.78837 10.8814V13.3279C7.90769 13.3235 7.99991 13.322 8.06604 13.322C8.34021 13.322 8.51396 13.2517 8.58954 13.1145C8.66532 12.9758 8.70249 12.5806 8.70249 11.9286C8.70249 11.5839 8.67107 11.3439 8.60925 11.2048C8.54744 11.0662 8.46693 10.9796 8.36712 10.944C8.26854 10.9065 8.07508 10.8871 7.78837 10.8814ZM7.78837 15.0408V18.1186C8.18084 18.1036 8.43181 18.0408 8.53943 17.9277C8.64766 17.8141 8.70249 17.5351 8.70249 17.0918V16.0669C8.70249 15.5958 8.65362 15.309 8.55627 15.2108C8.45933 15.1093 8.20261 15.0528 7.78837 15.0408ZM21.0925 9V20H18.6554V12.5732L17.6825 20H15.9535L14.9266 12.7434V20H12.4898V9H16.0987C16.205 9.66099 16.317 10.4398 16.4363 11.3378L16.8218 14.1366L17.4556 9H21.0925ZM25 9V20H22.2108V9H25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBmiMark);
export default __webpack_public_path__ + "static/media/BMI_mark.77f23c2670ff310d6571f92f34d4c3b4.svg";
export { ForwardRef as ReactComponent };